<div class="container-fluid generic-redeem-container" *ngIf="vm">
  <img osnSharedUseAsPicture class="background-image" [src]="vm.backgroundImgUrl" [imgQuery]="imgQuery" alt="" />
  <osn-shared-redeem-card #redeemCard [vm]="vm" (submitted)="onSubmit()" (loginError)="onLoginError()"></osn-shared-redeem-card>
</div>
